import moment from "moment-timezone";
export const FORMAT = "MM/DD/YYYY";
export const FORMATFORLASTSTEP = "YYYY-MM-DD";

export const saveDateForFistStep = (item) => {
  return moment(item).format(FORMATFORLASTSTEP);
};
export const convertUnixUTC = (date = toDate()) => {
  return moment.utc(date).unix() * 1000;
};
export const toDate = (date) => {
  return moment(date).toDate();
};
export const timeZoneGuess = () => {
  return moment.tz.guess();
};

export const currentDate = () => {
  return moment().unix() * 1000;
};
export const currentDateInUtc = () => {
  return moment().utc().unix() * 1000;
};

export const getMaxMinUnix = (date) => {
  return {
    startUnix: moment(date).startOf("day").unix() * 1000,
    endUnix: moment(date).endOf("day").unix() * 1000,
  };
};

export const getMonthLastDate = (date) => {
  const lastDate = moment(date).endOf("month");
  return moment(lastDate).endOf("day").valueOf();
};
